import React, { useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";

import { getRiskRatings } from "common/services/risk-assessments.service";
import { normalize } from "common/lib/normalize";
import { FilterSelect } from "Components/Common/TableFilters";

const SelectOverallRatingFilter = ({
  filterValue,
  setFilterValue,
}: {
  filterValue: any;
  setFilterValue: (value: any) => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>([]);
  const dispatch: any = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getRiskRatings({});
        setData(normalize(response.data));
      } catch (err: any) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FilterSelect
      id="overallRiskRating"
      placeholder="Select rating"
      value={filterValue?.overallRiskRating}
      onChange={setFilterValue}
      options={options}
      isLoading={loading}
    />
  );
};

export default SelectOverallRatingFilter;
